import { Fragment, h } from "preact";
import { observer } from "mobx-react";
import CartFirstOrderDiscount from "./CartFirstOrderDiscount";
import CartPromotionItem from "./CartPromotionItem";
import CartCoupon from "./CartCoupon";
import Alert from "../../components/Alert";
import { translate, t } from "../../I18n";
function CartPromotions(props) {
    const { promotions, fodController, fodState, couponState, cartMeetsCouponPromotionConditions, } = props;
    const hasFOD = fodState.type !== "Disabled" && fodController !== null;
    const hasPromotions = promotions.length > 0;
    const hasCouponEnabled = couponState.type !== "Disabled";
    const showPromotions = hasPromotions || hasCouponEnabled || hasFOD;
    const showCouponWarning = !cartMeetsCouponPromotionConditions;
    if (!showPromotions) {
        return null;
    }
    return (h("div", { class: "m-cart-promotions u-childs-separator" },
        hasFOD && (h(CartFirstOrderDiscount, { controller: fodController, state: fodState })),
        hasPromotions && (h("ul", { class: "u-list-unstyled" }, promotions.map((promotion) => (h(CartPromotionItem, { promotion: promotion, key: promotion.id }))))),
        hasCouponEnabled && (h(Fragment, null,
            h(CartCoupon, { state: couponState }),
            showCouponWarning && h(CartCouponWarning, null)))));
}
function CartCouponWarning() {
    return (h("div", { class: "item promotion" },
        h("div", { class: "cart-multi-column mobile" },
            h("div", { class: "column info" },
                h(Alert, { type: "warning", message: translate(t.restaurants.widgets.cart.no_coupon_items) })))));
}
export default observer(CartPromotions);
